import React, { useState } from "react";
import "./ProjectPage.css";

/* Modal */
import Modal from "./Modal";

/* Componet */
import HeaderPage from "../../components/Header/HeaderPage";
import Footer from "../../components/Footer/Footer";
import ParticleBackground from "../../components/ParticlesBg/ParticleBackground";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";

/* Multi idioma */
import { FormattedMessage } from "react-intl";

/* Img */
const proyectsImg = require.context("../../img", true);

const Project = () => {
  const [estadoModal7, cambiarEstadoModal7] = useState(false);
  const [estadoModal6, cambiarEstadoModal6] = useState(false);
  const [estadoModal5, cambiarEstadoModal5] = useState(false);
  const [estadoModal3, cambiarEstadoModal3] = useState(false);
  const [estadoModal8, cambiarEstadoModal8] = useState(false);
  const [estadoModal9, cambiarEstadoModal9] = useState(false);

  return (
    <div>
      <HeaderPage />

      <ParticleBackground />

      <main>
        <section className="projects__grid paginas-web">
        <div className="projects__item">
            <button
              onClick={() => cambiarEstadoModal9(!estadoModal9)}
              className="projects__img-btn"
              style={{ all: "unset", cursor: "pointer" }}
              aria-label="Open project X modal"
            >
              <img
                src={proyectsImg(`./proyecto-9.png`)}
                alt="Project 3"
                className="projects__img"
              />
            </button>
          </div> 

          <div className="projects__item">
            <button
              onClick={() => cambiarEstadoModal3(!estadoModal3)}
              className="projects__img-btn"
              style={{ all: "unset", cursor: "pointer" }}
              aria-label="Open project X modal"
            >
              <img
                src={proyectsImg(`./proyecto-3.png`)}
                alt="Project 3"
                className="projects__img"
              />
            </button>
          </div>       
          <div className="projects__item">
            <button
              onClick={() => cambiarEstadoModal6(!estadoModal6)}
              className="projects__img-btn"
              style={{ all: "unset", cursor: "pointer" }}
              aria-label="Open project X modal"
            >
              <img
                src={proyectsImg(`./proyecto-6.png`)}
                alt="Project 6"
                className="projects__img"
              />
            </button>
          </div>
          <div className="projects__item">
            <button
              onClick={() => cambiarEstadoModal5(!estadoModal5)}
              className="projects__img-btn"
              style={{ all: "unset", cursor: "pointer" }}
              aria-label="Open project X modal"
            >
              <img
                src={proyectsImg(`./proyecto-5.png`)}
                alt="Project X"
                className="projects__img"
              />
            </button>
          </div>
          <div className="projects__item">
            <button
              onClick={() => cambiarEstadoModal7(!estadoModal7)}
              className="projects__img-btn"
              style={{ all: "unset", cursor: "pointer" }}
              aria-label="Open project X modal"
            >
              <img
                src={proyectsImg(`./proyecto-7.png`)}
                alt="Project X"
                className="projects__img"
              />
            </button>
          </div>
          <div className="projects__item">
            <button
              onClick={() => cambiarEstadoModal8(!estadoModal8)}
              className="projects__img-btn"
              style={{ all: "unset", cursor: "pointer" }}
              aria-label="Open project X modal"
            >
              <img
                src={proyectsImg(`./proyecto-8.png`)}
                alt="Project X"
                className="projects__img"
              />
            </button>
          </div>
          
        </section>
      </main>

<Modal estado={estadoModal9} cambiarEstado={cambiarEstadoModal9}>
        <div className="content-modal">
          <div className="pw-content">
            <div className="eins-modal-preview">
              <img src={proyectsImg(`./proyecto-9.png`)} alt="" />
            </div>
            <div className="eins-modal-text">
              <p>
                <FormattedMessage
                  id="projects-info-7-p1"
                  defaultMessage="BlissPhool FlowerSuggestion Website."
                />
              </p>
              <p>
                <FormattedMessage
                  id="projects-info-7-p2"
                  defaultMessage="This Web is made for flower suggest for different Events"
                />
              </p>
              <div className="eins-modal-text-2">
                <span>Link:</span>{""}
                <a href="https://BlissPhool.com" target="_blank" rel="noreferrer">
                  https://fix-tool.com
                </a>
              </div>
<div className="eins-modal-text-3">
                <span>
                  <FormattedMessage
                    id="projects-tec"
                    defaultMessage="Used technology:"
                  />
                </span>
                <div className="eins-modal-tec">
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal estado={estadoModal7} cambiarEstado={cambiarEstadoModal7}>
        <div className="content-modal">
          <div className="pw-content">
            <div className="eins-modal-preview">
              <img src={proyectsImg(`./proyecto-7.png`)} alt="" />
            </div>
            <div className="eins-modal-text">
              <p>
                <FormattedMessage
                  id="projects-info-7-p1"
                  defaultMessage="Fix Tool, is a electronic Service website."
                />
              </p>
              <p>
                <FormattedMessage
                  id="projects-info-7-p2"
                  defaultMessage="Reliable electronic repair service offering quick diagnostics, affordable fixes, skilled technicians, genuine parts, customer support, and online booking convenience."
                />
              </p>
              <div className="eins-modal-text-2">
                <span>Link:</span>{" "}
                <a href="https://arunchy07.github.io/ChotuElectronics/" target="_blank" rel="noreferrer">
                  https://fix-tool.com
                </a>
              </div>

              <div className="eins-modal-text-3">
                <span>
                  <FormattedMessage
                    id="projects-tec"
                    defaultMessage="Used technology:"
                  />
                </span>
                <div className="eins-modal-tec">
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal estado={estadoModal6} cambiarEstado={cambiarEstadoModal6}>
        <div className="content-modal">
          <div className="pw-content">
            <div className="eins-modal-preview">
              <img src={proyectsImg(`./proyecto-6.png`)} alt="" />
            </div>
            <div className="eins-modal-text">
              <p>
                <FormattedMessage
                  id="projects-info-6-p1"
                  defaultMessage="Bliss-Phool, is a Flower Suggestion Website."
                />
              </p>
              <p>
                <FormattedMessage
                  id="projects-info-6-p2"
                  defaultMessage="Discover vibrant, handpicked blooms—roses, lilies, orchids, tulips—perfect for every occasion, expressing love, joy, and heartfelt moments."
                />
              </p>
              <div className="eins-modal-text-2">
                <span>Link:</span>{" "}
                <a
                  href=" https://bliss_Phool.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://bliss_Phool.com
                </a>
              </div>
              <div className="eins-modal-text-3">
                <span>
                  <FormattedMessage
                    id="projects-tec"
                    defaultMessage="Used technology:"
                  />
                </span>
                <div className="eins-modal-tec">
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg"
                    alt=""
                  />
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal estado={estadoModal5} cambiarEstado={cambiarEstadoModal5}>
        <div className="content-modal">
          <div className="pw-content">
            <div className="eins-modal-preview">
              <img src={proyectsImg(`./proyecto-5.png`)} alt="" />
            </div>
            <div className="eins-modal-text">
              <p>
                <FormattedMessage
                  id="projects-info-5-p1"
                  defaultMessage="Radha Krishna Pharmacy, is pharmacy store website ."
                />
              </p>
              <p>
                <FormattedMessage
                  id="projects-info-5-p2"
                  defaultMessage="Radha Krishna Pharmacy delivers trusted healthcare solutions, quality medicines, wellness products, and expert care to your doorstep with love and commitment."
                />
              </p>
              <div className="eins-modal-text-2">
                <span>Link:</span>{" "}
                <a
                  href="https://arunchy07.github.io/radha/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://RadhaKrishnaPharmacy.com
                </a>
              </div>
              <div className="eins-modal-text-3">
                <span>
                  <FormattedMessage
                    id="projects-tec"
                    defaultMessage="Used technology:"
                  />
                </span>
                <div className="eins-modal-tec">
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg"
                    alt=""
                  />
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg"
                    alt=""
                  />
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal estado={estadoModal3} cambiarEstado={cambiarEstadoModal3}>
        <div className="content-modal">
          <div className="pw-content">
            <div className="eins-modal-preview">
              <img src={proyectsImg(`./proyecto-3.png`)} alt="" />
            </div>
            <div className="eins-modal-text">
              <p>
                <FormattedMessage
                  id="projects-info-3-p1"
                  defaultMessage="BLUEMOO, is Dairy website"
                />
              </p>
              <p>
                <FormattedMessage
                  id="projects-info-3-p2"
                  defaultMessage="Developed and maintained the BLUEMOO Dairy website, showcasing products, nutritional details, and promotions with a user-friendly interface."
                />
              </p>
              <div className="eins-modal-text-2">
                <span>Link:</span>
                <a href="https://BlueMoo.com" target="_blank" rel="noreferrer">
                  https://BlueMoo.com
                </a>
              </div>
              <div className="eins-modal-text-3">
                <span>
                  <FormattedMessage
                    id="projects-tec"
                    defaultMessage="Used technology:"
                  />
                </span>
                <div className="eins-modal-tec">
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg"
                    alt=""
                  />
                  <img
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg"
                    alt=""
                  />

                  <img
                    src="https://logowik.com/content/uploads/images/tailwind-css3232.logowik.com.webp"
                    alt=""
                  />
                  <img
                    src="https://download.logo.wine/logo/Django_(web_framework)/Django_(web_framework)-Logo.wine.png"
                    alt=""
                  />
                    <img
                    src="https://tse1.mm.bing.net/th/id/OIP.BxNFQE_tKp5YJ8XVx9PAdgHaGQ?rs=1&pid=ImgDetMain&o=7&rm=3"
                    alt=""
                  />
                  <img
                    src="https://tse3.mm.bing.net/th/id/OIP.KvXJa7Z1CKC9CmoSn4jCZAHaHU?rs=1&pid=ImgDetMain&o=7&rm=3"
                    alt=""
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
<Modal estado={estadoModal8} cambiarEstado={cambiarEstadoModal8}>
        <div className="content-modal">
          <div className="pw-content">
            <div className="eins-modal-preview">
              <img src={proyectsImg(`./proyecto-8.png`)} alt="" />
            </div>
            <div className="eins-modal-text">
              <p>
                <FormattedMessage
                  id="projects-info-8-p1"
                  defaultMessage="Mad Libs Generator Or Story Generator"
                />
              </p>
              <p>
                <FormattedMessage
                  id="projects-info-8-p2"
                  defaultMessage="Developed an interactive Mad Libs project using Python that dynamically generates fun and personalized stories based on user input. Implemented a Tkinter-based GUI to allow users to enter nouns, verbs, adjectives, places, and other words, which are then inserted into randomly selected story templates."
                />
              </p>
              <div className="eins-modal-text-2">
                <span>Link:</span>{" "}
                <a href="https://Mad-lips.com" target="_blank" rel="noreferrer">
                  https://Mad-lips.com
                </a>
              </div>
              <div className="eins-modal-text-3">
                <span>
                  <FormattedMessage
                    id="projects-tec"
                    defaultMessage="Used technology:"
                  />
                </span>
                <div className="eins-modal-tec">
                  <img
                    src="https://tse4.mm.bing.net/th/id/OIP.dJToM1TiZiJA0GYwzDHwjQHaHY?rs=1&pid=ImgDetMain&o=7&rm=3"
                    alt=""
                  />
                  <img
                    src="https://1.bp.blogspot.com/-2JFX5AsWbbU/Wp428R7Z0JI/AAAAAAAAEyk/Fob3mX_pLvU64_LRdLBwqBQXAX5dBERfQCLcBGAs/s1600/write-a-python-tkinter-based-desktop-app.png"
                    alt=""
                  />
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

<ScrollToTop />

<Footer />
 </div>   
     
  );
};
export default Project;
